import type {
  HotelDetailV2ComparisonItem,
  HotelDetailV2FaqItem,
  HotelDetailV2Image,
  HotelDetailV2Model,
  HotelDetailV2NearbyLink,
  HotelDetailV2RatingCategory,
  HotelDetailV2Review,
  HotelDetailV2SimilarHotel,
} from "./hotelDetailV2.model";

export const DETAIL_V2_SAMPLE_RATING = {
  value: 9.2,
  count: 324,
  label: "عالی",
  isSample: true,
} as const;

export const DETAIL_V2_SAMPLE_GUEST_IMAGES: HotelDetailV2Image[] = [
  "https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1559508551-44bff1de756b?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1519690889869-e705e59f72e1?w=1200&h=800&fit=crop",
].map((url, index) => ({
  id: `sample-guest-${index + 1}`,
  url,
  alt: `تصویر نمونه کاربر ${index + 1}`,
  type: "large",
  source: "guest",
}));

export const DETAIL_V2_SAMPLE_OFFICIAL_IMAGES = [
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&h=1000&fit=crop",
  "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=1200&h=800&fit=crop",
  "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=1200&h=800&fit=crop",
];

export const DETAIL_V2_SAMPLE_RATING_CATEGORIES: HotelDetailV2RatingCategory[] = [
  { title: "پاکیزگی", value: 9.4, isSample: true },
  { title: "موقعیت", value: 9.1, isSample: true },
  { title: "برخورد کارکنان", value: 9.3, isSample: true },
  { title: "ارزش خرید", value: 8.8, isSample: true },
];

export const DETAIL_V2_SAMPLE_REVIEWS: HotelDetailV2Review[] = [
  {
    id: "sample-review-1",
    author: "مسافر تایید شده",
    value: 9.6,
    body: "اتاق تمیز بود، دسترسی به مرکز شهر خوب بود و پذیرش خیلی سریع انجام شد.",
    dateLabel: "بهار ۱۴۰۵",
    verified: true,
    isSample: true,
  },
  {
    id: "sample-review-2",
    author: "مهمان خانوادگی",
    value: 8.9,
    body: "صبحانه کامل بود و برای سفر خانوادگی انتخاب راحتی محسوب می‌شود.",
    dateLabel: "زمستان ۱۴۰۴",
    verified: true,
    isSample: true,
  },
];

export function getDetailV2SampleSimilarHotels(
  city: string,
): HotelDetailV2SimilarHotel[] {
  return [
    {
      id: "sample-similar-1",
      title: `هتل پنج ستاره ${city}`,
      href: "#",
      imageUrl:
        "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?w=600&h=420&fit=crop",
      stars: 5,
      ratingLabel: "عالی",
      priceLabel: "شروع قیمت از ۳,۸۰۰,۰۰۰ تومان",
      distanceLabel: "نزدیک مرکز شهر",
      isSample: true,
    },
    {
      id: "sample-similar-2",
      title: "هتل نزدیک حرم",
      href: "#",
      imageUrl:
        "https://images.unsplash.com/photo-1568495248636-6432b97bd949?w=600&h=420&fit=crop",
      stars: 4,
      ratingLabel: "خیلی خوب",
      priceLabel: "شروع قیمت از ۲,۹۵۰,۰۰۰ تومان",
      distanceLabel: "دسترسی آسان",
      isSample: true,
    },
    {
      id: "sample-similar-3",
      title: "هتل اقتصادی محبوب",
      href: "#",
      imageUrl:
        "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=600&h=420&fit=crop",
      stars: 4,
      ratingLabel: "خوب",
      priceLabel: "شروع قیمت از ۲,۴۰۰,۰۰۰ تومان",
      distanceLabel: "مناسب سفر کاری",
      isSample: true,
    },
  ];
}

export const DETAIL_V2_SAMPLE_COMPARISON: HotelDetailV2ComparisonItem[] = [
  {
    id: "sample-comparison-1",
    title: "امتیاز کاربران",
    currentValue: "۹.۲ از ۱۰",
    nearbyValue: "۸.۶ از ۱۰",
    isCurrentBetter: true,
    isSample: true,
  },
  {
    id: "sample-comparison-2",
    title: "تنوع اتاق",
    currentValue: "بالاتر از میانگین",
    nearbyValue: "میانگین",
    isCurrentBetter: true,
    isSample: true,
  },
  {
    id: "sample-comparison-3",
    title: "دسترسی",
    currentValue: "نزدیک نقاط مهم",
    nearbyValue: "وابسته به مسیر",
    isCurrentBetter: true,
    isSample: true,
  },
];

export const DETAIL_V2_SAMPLE_FAQS: HotelDetailV2FaqItem[] = [
  {
    id: "sample-faq-1",
    question: "آیا امکان رزرو آنلاین این هتل وجود دارد؟",
    answer: "بله، پس از انتخاب اتاق و نرخ قابل رزرو وارد مرحله ثبت مسافران می‌شوید.",
    isSample: true,
  },
  {
    id: "sample-faq-2",
    question: "قوانین کنسلی از کجا مشخص می‌شود؟",
    answer: "قانون کنسلی برای هر نرخ اتاق نمایش داده می‌شود و ممکن است بین نرخ‌ها متفاوت باشد.",
    isSample: true,
  },
  {
    id: "sample-faq-3",
    question: "قیمت نمایش داده‌شده برای چند شب است؟",
    answer: "جمع قیمت بر اساس تاریخ ورود، خروج، تعداد شب و تعداد اتاق انتخاب‌شده محاسبه می‌شود.",
    isSample: true,
  },
];

export function getDetailV2SampleNearbyLinks(
  city: string,
): HotelDetailV2NearbyLink[] {
  return [
    {
      id: "sample-nearby-1",
      title: `هتل‌های نزدیک مرکز ${city}`,
      href: "#",
      countLabel: "۱۲ هتل",
      isSample: true,
    },
    {
      id: "sample-nearby-2",
      title: "هتل‌های خانوادگی",
      href: "#",
      countLabel: "۸ هتل",
      isSample: true,
    },
    {
      id: "sample-nearby-3",
      title: "هتل‌های چهار ستاره",
      href: "#",
      countLabel: "۱۵ هتل",
      isSample: true,
    },
  ];
}

export function getDetailV2SampleHotel(
  city: string,
  slug: string,
): HotelDetailV2Model | null {
  if (city.toUpperCase() !== "MHD" || slug !== "Mashhad-Darvishi") {
    return null;
  }

  return {
    id: "sample-mashhad-darvishi",
    slug,
    city: { iata: "MHD", name: "مشهد" },
    name: "هتل درویشی مشهد",
    englishName: "Darvishi Hotel Mashhad",
    stars: 5,
    rating: DETAIL_V2_SAMPLE_RATING,
    ratingCategories: DETAIL_V2_SAMPLE_RATING_CATEGORIES,
    reviews: DETAIL_V2_SAMPLE_REVIEWS,
    similarHotels: getDetailV2SampleSimilarHotels("مشهد"),
    comparison: DETAIL_V2_SAMPLE_COMPARISON,
    faqs: DETAIL_V2_SAMPLE_FAQS,
    nearbyLinks: getDetailV2SampleNearbyLinks("مشهد"),
    address: "خیابان امام رضا، بین امام رضا ۲۴ و ۲۶",
    shortDescription: "هتل پنج ستاره درویشی مشهد در نزدیکی حرم مطهر قرار دارد.",
    images: DETAIL_V2_SAMPLE_OFFICIAL_IMAGES.map((url, index) => ({
      id: `sample-official-${index + 1}`,
      url,
      alt: index === 0 ? "هتل درویشی مشهد" : `هتل درویشی مشهد ${index + 1}`,
      type: index === 0 ? "large" : "thumbnail",
      source: "official",
    })),
    facilities: [],
    distances: [],
  };
}
